const { InspectorControls } = wp.editor;
const { PanelBody, ToggleControl, RangeControl } = wp.components;
import CommonPanel from '../wp-controlers/common-panel';

const Inspector = ({ attributes, setAttributes }) => {
  const {
    hasNavigation,
    loop,
    containerized,
    centered,
    hasNavigationDesktop,
    cardSpace,
    dots,
    slidesPerView,
    slidesPerView768,
    slidesPerView1280,
    slidesPerView1580,
    hasFakeItem,
  } = attributes;

  return (
    <InspectorControls>
      <PanelBody title="Atributos do carrossel" initialOpen={true}>
        <ToggleControl
          label="Este carrossel está fora de um container?"
          checked={containerized}
          onChange={() =>
            setAttributes({
              containerized: !containerized,
              hasFakeItem: false,
            })
          }
        />

        {!containerized && (
          <ToggleControl
            label="Adicionar item fake para alinhar ao container?"
            checked={hasFakeItem}
            onChange={() => setAttributes({ hasFakeItem: !hasFakeItem })}
          />
        )}

        <ToggleControl
          label="Setas de navegação no mobile?"
          checked={hasNavigation}
          onChange={() => setAttributes({ hasNavigation: !hasNavigation })}
        />

        <ToggleControl
          label="Setas de navegação em desktop?"
          checked={hasNavigationDesktop}
          onChange={() =>
            setAttributes({ hasNavigationDesktop: !hasNavigationDesktop })
          }
        />

        <ToggleControl
          label="Adicionar paginação (dots)?"
          checked={dots}
          onChange={() => setAttributes({ dots: !dots })}
        />

        <ToggleControl
          label="Os itens do carrossel seram centralizados?"
          checked={centered}
          onChange={() => setAttributes({ centered: !centered })}
        />

        <ToggleControl
          label="O carrossel irá ser em loop ?"
          checked={loop}
          onChange={() => setAttributes({ loop: !loop })}
        />

        <RangeControl
          label="Espaçamento entre os itens (em px):"
          initialPosition={cardSpace}
          value={cardSpace}
          onChange={(value) => setAttributes({ cardSpace: value })}
          min={1}
          max={50}
        />
      </PanelBody>

      <PanelBody title="Atributos responsivos" initialOpen={true}>
        <RangeControl
          label="Slides visíveis abaixo de 768px:"
          initialPosition={slidesPerView}
          value={slidesPerView}
          onChange={(value) => setAttributes({ slidesPerView: value })}
          min={1}
          step={0.1}
          max={5}
        />

        <RangeControl
          label="Slides visíveis acima de 768px:"
          initialPosition={slidesPerView768}
          value={slidesPerView768}
          onChange={(value) => setAttributes({ slidesPerView768: value })}
          min={1}
          step={0.1}
          max={5}
        />

        <RangeControl
          label="Slides visíveis acima de 1280px:"
          initialPosition={slidesPerView1280}
          value={slidesPerView1280}
          onChange={(value) => setAttributes({ slidesPerView1280: value })}
          min={1}
          step={0.1}
          max={5}
        />

        <RangeControl
          label="Slides visíveis acima de 1580:"
          initialPosition={slidesPerView1580}
          value={slidesPerView1580}
          onChange={(value) => setAttributes({ slidesPerView1580: value })}
          min={1}
          step={0.1}
          max={5}
        />
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
};

export default Inspector;
